module.exports = __webpack_public_path__ + "img/paypal.370e2df7.png";